import {
  IAnalyticsEvent,
  //   IPageData,
  TDigitalData,
  IEventInfo,
  TEventCategory,
  //   IError,
  //   TErrorTypes,
  //   TErrorDisplayTypes,
} from '../models/common/analytics';

// // Temporary fix for life cycle event bus
// declare global {
//   interface Window {
//     LIFE_CYCLE_EVENT_BUS: any;
//   }
// }

// const sendToBus = (name: string, payload: any) => {
//   window.LIFE_CYCLE_EVENT_BUS.trigger(name, payload);
// };

// export const analyticsOverlay = (area: string) => {
//   sendToBus('customer-loyalty.loyalty-overlay', { settings: area });
// };

// export const analyticsStash = (area: string) => {
//   sendToBus('customer-loyalty.loyalty-stash', { settings: area });
// };

// export const analyticsClick = (area: string) => {
//   sendToBus('customer-loyalty.loyalty-button', { settings: area });
// };

const setEvent = (
  eventCategory: TEventCategory,
  eventInfo: IEventInfo,
  payload?: Record<string, unknown>,
) => {
  pushEventInfo({
    category: {
      primaryCategory: eventCategory,
    },
    eventInfo,
    ...payload,
  });
};

// export const setPageInfo = (
//   errorType: TErrorTypes,
//   displayType: TErrorDisplayTypes,
//   pageSection: string,
//   errorMessage: string,
//   errorCode: string,
// ) => {
//   pushPageErrorInfo({
//     errorType,
//     displayType,
//     pageSection,
//     errorMessage,
//     errorCode,
//   });
// };
// export const pushPageErrorInfo = (pageError: IError) => {
//   if (pageError && window.digitalData) {
//     window.digitalData.page.error = window.digitalData.page.error || [];
//     window.digitalData.page.error.push(pageError);

//     setAnalytics(window.digitalData);
//   }
// };

// export const setEditEvent = (area: string, field: string) => {
//   setEvent(
//     'button submission',
//     {
//       eventName: 'my account settings',
//     },
//     {
//       myAccount: {
//         settings: `${area}: ${field}`,
//       },
//     },
//   );
// };

export const clickCta = (area: string) => {
  setEvent(
    'button submission',
    {
      eventName: 'my account settings',
    },
    {
      myAccount: {
        settings: `${area}`,
      },
    },
  );
};

// export const tooltipHover = (area: string) => {
//   setEvent('tooltip', {
//     eventName: area,
//   });
// };

// const setErrorEvent = (
//   pageSection: string,
//   errorCode: string,
//   errorMessage: string,
//   displayType: string,
// ) => {
//   setEvent('error', {
//     eventName: 'post page error',
//     error: {
//       errorType: 'error',
//       displayType,
//       pageSection,
//       errorCode,
//       errorMessage,
//     },
//   });
// };

// export const pushErrorEvent = (
//   pageSection: string,
//   displayType = 'inline',
//   errCode: string,
//   errMessage: string,
// ) => {
//   setErrorEvent(pageSection, errCode, errMessage, displayType);
// };

export const setStashEvent = (
  eventCategory: TEventCategory,
  eventInfo: IEventInfo,
  eventMode: TEventCategory,
  payload?: Record<string, unknown>,
) => {
  pushEventInfo({
    category: {
      primaryCategory: eventCategory,
    },
    eventInfo,
    eventMode,
    ...payload,
  });
};

export const stashLinkEvent = (action: string) => {
  setStashEvent(
    'stash',
    {
      eventName: 'my account settings',
    },
    'stash',
    {
      stash: { myAccount: { settings: action } },
    },
  );
};

export const setOverlayEvent = (
  eventName: string,
  payload?: Record<string, unknown>,
) => {
  setEvent(
    'overlay',
    {
      eventName,
    },
    payload,
  );
};

// /**
//  * Function for updating page data in the global variable _T
//  * @param digitalData - the digital data object we want to push to page data array
//  * @returns undefined
//  */
export const setAnalytics = (digitalData: TDigitalData) => {
  const _ddo = digitalData.init();

  window._T = window._T || {};

  if (typeof window._T.pageData === 'undefined') {
    window._T.pageData = [];
  }

  window._T.pageData.push(_ddo);
};

// /**
//  * Function for updating an event array in the global variable digitalData
//  * @param analyticsEvent - an event object we want to push to event array
//  * @returns undefined
//  */
export const pushEventInfo = (analyticsEvent: IAnalyticsEvent) => {
  if (analyticsEvent && window.digitalData) {
    try {
      window.digitalData.event = window.digitalData.event || [];
      window.digitalData.event.push(analyticsEvent);

      setAnalytics(window.digitalData);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('DDO : Error in pushing the event info!!!');
    }
  }
};

// /**
//  * Function for setting page details in the global variable digitalData
//  * @param page - an page details object we want to set in the digitalData
//  * @returns undefined
//  */
// export function setPageDetails(page: IPageData) {
//   if (window.digitalData) {
//     try {
//       window.digitalData.page = page;
//       setAnalytics(window.digitalData);
//     } catch (err) {
//       // eslint-disable-next-line no-console
//       console.error(
//         'DDO : Error in setting the page object and initializing it!!!',
//       );
//     }
//   }
// }
